import findIndex from 'lodash/findIndex'

export default function findNextKey(key: string, itemKeys: string[]) {
  const index = findIndex(itemKeys, (itemKey) => itemKey === key)
  if (index === itemKeys.length - 1 || index === -1) {
    return null
  }
  return itemKeys[index + 1]
}
